import React, { useEffect, useState } from 'react'
import styles from '../../../Assets/Styles/Components/Book/Photograpers/filters.module.css'

const Filters = props => {
  const { grades, gender, show, onClose, onChangeFilters } = props
  const [inGender, setInGender] = React.useState(gender)
  const [inGrades, setInGrades] = React.useState(grades)

  const addLevel = e => {
    if (inGrades.includes(e.target.value)) {
      setInGrades([...inGrades].filter(i => i !== e.target.value))
    } else {
      setInGrades([...inGrades, e.target.value])
    }
  }

  const onChangeGender = e => {
    setInGender(e)
  }
  const onChangeFilter = e => {
    onChangeFilters(inGender, inGrades)
  }

  useEffect(() => {
    if (gender !== inGender) {
      setInGender(inGender)
    }
    if (grades !== inGrades) {
      setInGrades(grades)
    }
  }, [grades, gender])

  return (
    <div
      className={`${styles.comments} ${show ? styles.show : ''}`}
      onClick={onClose}
    >
      <div
        className={styles.container}
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <div className={styles.title}>
          <div className={styles.titleName}> فیلترها </div>
          <div className={styles.closeBtn} onClick={onClose} />
        </div>
        <div className={styles.content}>
          <div className={styles.genderContainer}>
            <p>
              <b>جنسیت :</b>{' '}
            </p>
            <div className={styles.genders}>
              <div
                className={`${styles.gender} ${
                  inGender === 0 ? styles.genderActive : ''
                }`}
                onClick={_ => onChangeGender(0)}
              >
                همه
              </div>
              <div
                className={`${styles.gender} ${
                  inGender === 1 ? styles.genderActive : ''
                }`}
                onClick={_ => onChangeGender(1)}
              >
                خانم
              </div>
              <div
                className={`${styles.gender} ${
                  inGender === 2 ? styles.genderActive : ''
                }`}
                onClick={_ => onChangeGender(2)}
              >
                آقا
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.content}>
            <div className={styles.genderContainer}>
              <p>
                <b>سطح متخصص:</b>{' '}
              </p>
              <div className={styles.grades}>
                {grades?.length > 0 &&
                  grades.map(i => {
                    return (
                      <div key={i} className={styles.gradeItem}>
                        <input
                          type='checkbox'
                          id={i}
                          name={i}
                          value={i}
                          onChange={addLevel}
                          checked={inGrades.includes(i)}
                        />
                        <label htmlFor={i}>{i}</label>
                      </div>
                    )
                  })}
              </div>
            </div>
            <div className='container'>
              <div className='row my-3'>
                <div className="col-6">
                  مرتب سازی براساس:
                </div>
                <div className="col-6">
                  <select
                    name="sorts"
                    id="sorts"
                    value={props.sort}
                    onChange={(e) => props.onChangeSort(e.target.value)}
                    className={styles.formSelect}
                    aria-label="Default select example"
                  >
                    {props.sortItems.map((i) => (
                      <option key={i.value} value={i.value}>
                        {i.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className='row mt-3'>
                <button
                  type='button'
                  disabled={inGrades.length === 0}
                  className={`col-12 ${styles.btn}`}
                  onClick={onChangeFilter}
                >
                  <b>مشاهده متخصصین</b>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filters
